import { createSlice } from "@reduxjs/toolkit";

const initialAuthData = {
    authenticated: "",
    username: "",
    first_name: "",
    last_name: "",
    role: "",
    user_id: "",
    user_email: "",
    mobile_number: "",
    user_status: "",
    school_id: "",
    school_name: "",
    school_branch: "",
    school_address: "",
    school_contact: "",
    profile_image_url: "",
    subscription_plan: "",
};

export const AuthStatusSlices = createSlice({
    name: 'authInfo',
    initialState: {
        data: { ...initialAuthData },
    },
    reducers: {
        addSchoolUserInfo(state, action){
            const p = action.payload || {};
            state.data.authenticated = p.user_authenticated
            state.data.username = p.user_username
            state.data.first_name = p.user_first_name ?? state.data.first_name ?? ""
            state.data.last_name = p.user_last_name ?? state.data.last_name ?? ""
            state.data.role = p.user_role
            state.data.user_id = p.user_user_id
            state.data.user_email = p.user_user_email
            state.data.mobile_number = p.user_mobile_number ?? state.data.mobile_number ?? ""
            state.data.user_status = p.user_user_status ?? state.data.user_status ?? ""
            state.data.school_id = p.user_school_id
            state.data.school_name = p.user_school_name
            state.data.school_branch = p.user_school_branch ?? ""
            state.data.school_address = p.user_school_address ?? ""
            state.data.school_contact = p.user_school_contact ?? ""
            if (p.user_profile_image_url !== undefined) {
                state.data.profile_image_url = p.user_profile_image_url || ""
            }
            if (p.user_subscription_plan !== undefined) {
                state.data.subscription_plan = p.user_subscription_plan || ""
            }
        },
        setProfileImageUrl(state, action) {
            state.data.profile_image_url = action.payload || "";
        },
        clearSchoolUserInfo(state) {
            state.data = { ...initialAuthData };
        },
    }
})
export const { addSchoolUserInfo, clearSchoolUserInfo, setProfileImageUrl } = AuthStatusSlices.actions;

export default AuthStatusSlices.reducer;
